import { CollapseStates } from '@picsart/design-system/components/EditorSlot';

import type { BottomSheetConfig } from 'types/store';

export const createFloatingConfig = (normalHeight: number, maximalHeight?: number): BottomSheetConfig => ({
  behavior: 'floating',
  collapseStates: maximalHeight ? { normal: { height: normalHeight }, maximal: { height: maximalHeight } } : { normal: { height: normalHeight } },
  defaultSnapPoint: CollapseStates.Normal,
});
